import {
  Avatar,
  CardContent,
  Chip,
  Divider,
  Grid,
  Typography,
  CardHeader,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import BlankCard from "src/components/shared/BlankCard";
import { IconCalendar } from "@tabler/icons";
import { useParams } from "react-router";
import vehicleProfileService from "src/service/vehicleProfile";
import {
  DirectionsRenderer,
  GoogleMap,
  LoadScript,
  Marker,
} from "@react-google-maps/api";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { mapOptions } from "src/config/mapOptions";
import StopsTimeline from "./StopsTimeline";

const SingleTripDetails = () => {
  const [tripData, setTripData] = useState([]);
  const [timelineData, setTimelineData] = useState([]);
  const param = useParams();

  const [finalData, setFinalData] = useState([]);

  const [directions, setDirections] = useState(null);
  const [startMarker, setStartMarker] = useState({
    position: { lat: 0, lng: 0 },
    address: "",
  });

  const [endMarker, setEndMarker] = useState({
    position: { lat: 0, lng: 0 },
    address: "",
  });

  useEffect(() => {
    const fetchRouteDetails = async () => {
      try {
        const res = await vehicleProfileService.getTripReportData({
          id: param.id,
        });

        setTripData(res.data[0]);
        const routeData = res.data[0];

        setStartMarker({
          position: {
            lat: parseFloat(routeData.start_lat),
            lng: parseFloat(routeData.start_lng),
          },
          address: "",
        });

        setEndMarker({
          position: {
            lat: parseFloat(routeData.end_lat),
            lng: parseFloat(routeData.end_lng),
          },

          address: "",
        });
        fetchTimelineData(routeData);
      } catch (error) {
        console.log(error);
      }
    };

    fetchRouteDetails();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const BCrumb = [
    {
      to: "/",
      title: "Home",
    },
    {
      title: tripData?.vehicle_no,
    },
  ];

  const fetchTimelineData = async (routeData) => {
    try {
      const res = await vehicleProfileService.getTripTimelineData({
        imei_no: routeData.imei_no,
        from_date_time: moment(routeData.start_date_time).format(
          "YYYY-MM-DD H:mm:ss"
        ),
        to_date_time: moment(routeData.end_date_time).format(
          "YYYY-MM-DD H:mm:ss"
        ),
      });

      setTimelineData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (startMarker.position.lat && endMarker.position.lat) {
      setTimeout(() => {
        calculateDirections();
      }, [1000]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startMarker, endMarker, param.id]);

  const calculateDirections = () => {
    const directionsService = new window.google.maps.DirectionsService();

    directionsService.route(
      {
        origin: startMarker.position,
        destination: endMarker.position,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },

      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          setDirections(result);
        } else {
          console.error("Directions request failed due to " + status);
        }
      }
    );
  };
  // ==================== segregate timeline data ===============

  const findPlaceName = async (lat, lng) => {
    const apiKey = "AIzaSyBv9jDq8JKDbXupuD_pHFyNwobWHysQLEo";

    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch place name");
      }

      const data = await response.json();

      // Check if the response contains results
      if (data.results && data.results.length > 0) {
        // Extract the formatted address from the first result
        const placeName = data.results[0].formatted_address;
        return placeName;
      } else {
        return "Unknown Place";
      }
    } catch (error) {
      console.error("Error:", error.message);
      return "Unknown Place";
    }
  };

  let stopsArray = [];
  const findLongStopsWithPlaceNames = async (timelineData) => {
    let stopStartTime = null;
    let stopEndTime = null;

    if (!Array.isArray(timelineData)) {
      console.log("timelineData is not an array:", timelineData);
      return;
    }

    for (const point of timelineData) {
      if (point.speed === 0 && !stopStartTime) {
        stopStartTime = new Date(point._time);
      }

      if (
        (point.speed > 0 || point === timelineData[timelineData.length - 1]) &&
        stopStartTime
      ) {
        stopEndTime = new Date(point._time);

        const stopDuration = stopEndTime - stopStartTime;

        if (stopDuration > 5 * 60 * 1000) {
          const placeName = await findPlaceName(point.lat, point.lng);

          const stopInfo = {
            startTime: stopStartTime,
            endTime: stopEndTime,
            duration: stopDuration / (1000 * 60), // duration in minutes
            location: `Lat: ${point.lat}, Lng: ${point.lng}`,
            placeName: placeName,
          };

          stopsArray.push(stopInfo);
        }

        stopStartTime = null;
        stopEndTime = null;
      }
    }

    setFinalData(stopsArray);
  };

  useEffect(() => {
    findLongStopsWithPlaceNames(timelineData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timelineData]);

  return (
    <>
      <Breadcrumb title="Trip" items={BCrumb} />
      <Grid container spacing={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <BlankCard>
            <CardHeader title={tripData?.trip_name ?? "NA"} />
            <Divider />{" "}
            <LoadScript googleMapsApiKey="AIzaSyBv9jDq8JKDbXupuD_pHFyNwobWHysQLEo">
              <GoogleMap
                mapContainerStyle={{
                  height: "400px",
                  width: "100%",
                  marginTop: "20px",
                }}
                options={mapOptions}
                zoom={10}
                center={startMarker.position}
              >
                {directions && <DirectionsRenderer directions={directions} />}

                <Marker position={startMarker.position} />
                <Marker position={endMarker.position} />
              </GoogleMap>
            </LoadScript>
          </BlankCard>
        </Grid>

        <Grid item lg={7} md={7} sm={6} xs={12} mt={2}>
          <BlankCard>
            <CardContent
              style={{
                cursor: "pointer",
              }}
            >
              <>
                <Grid
                  container
                  spacing={3}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Grid item xs={12} lg={12} md={6} sm={12}>
                    <Grid container spacing={3} alignItems="center">
                      <Grid
                        item
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        sx={{
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                        style={{
                          borderRight: {
                            xs: "none",
                            sm: "1px solid silver",
                          },
                        }}
                      >
                        <div className="mb-1">
                          <Typography variant="h6" style={{ fontSize: "14px" }}>
                            Start DateTime
                          </Typography>
                          <Chip
                            variant="outlined"
                            avatar={
                              <Avatar style={{ backgroundColor: "#e6fffa" }}>
                                <IconCalendar size={15} color="#1adfbb" />
                              </Avatar>
                            }
                            label={
                              moment(tripData?.start_date_time).format(
                                "DD-MM-YYYY h:mm a"
                              ) ?? "NA"
                            }
                          />
                        </div>
                        <hr className="my-2" />
                        <div className="mb-1">
                          <Typography
                            variant="h6"
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                          >
                            End DateTime
                          </Typography>
                          <Chip
                            variant="outlined"
                            avatar={
                              <Avatar
                                style={{
                                  backgroundColor: "#FDEDE8",
                                  textAlign: "center",
                                }}
                              >
                                <IconCalendar size={15} color="#FA896B" />
                              </Avatar>
                            }
                            label={
                              moment(tripData?.end_date_time).format(
                                "DD-MM-YYYY hh:mm a"
                              ) ?? "NA"
                            }
                          />
                        </div>
                      </Grid>
                      <Grid
                        item
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        sx={{
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                        style={{
                          borderRight: {
                            xs: "none",
                            sm: "1px solid silver",
                          },
                        }}
                      >
                        <Typography variant="h6" style={{ fontSize: "14px" }}>
                          Travelled Distance
                        </Typography>
                        <Typography variant="h5" color="textSecondary">
                          {parseFloat(tripData?.total_distance).toFixed(2)} Km
                        </Typography>
                        <hr className="my-2" />
                        <Typography variant="h6" style={{ fontSize: "14px" }}>
                          Avg. Speed
                        </Typography>
                        <Typography variant="h5" color="textSecondary">
                          {parseFloat(tripData?.avg_speed).toFixed(2)} Km/H
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        sx={{
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                        style={{
                          borderRight: {
                            xs: "none",
                            sm: "1px solid silver",
                          },
                        }}
                      >
                        <Typography variant="h6" style={{ fontSize: "14px" }}>
                          Top Speed
                        </Typography>
                        <Typography variant="h5" color="textSecondary">
                          {parseFloat(tripData?.top_speed).toFixed(2)} Km/H
                        </Typography>
                        <hr className="my-2" />
                        <Typography variant="h5" style={{ fontSize: "14px" }}>
                          Duration
                        </Typography>
                        <Typography
                          variant="h4"
                          color="textSecondary"
                        >{`${Math.floor(
                          moment
                            .duration(
                              moment(tripData?.end_date_time).diff(
                                moment(tripData?.start_date_time)
                              )
                            )
                            .asHours()
                        )} Hrs ${moment
                          .duration(
                            moment(tripData?.end_date_time).diff(
                              moment(tripData?.start_date_time)
                            )
                          )
                          .minutes()} Min`}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            </CardContent>
          </BlankCard>
        </Grid>
        {/* ============================= */}
        <Grid item lg={5} md={5} sm={6} xs={12} mt={2}>
          <StopsTimeline stopageData={finalData} />
        </Grid>
      </Grid>
    </>
  );
};

export default SingleTripDetails;
